import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { spotFinder } from './endpoints';
import axiosBaseQuerySpotfinder from './axiosBaseQuerySpotfinder';

export const parkingCategoryApi = createApi({
  reducerPath: 'parkingCategoryApi',
  baseQuery: axiosBaseQuerySpotfinder({ baseUrl: process.env.REACT_APP_SPOT_FINDER_BASE_URL }),
  tagTypes: ['parkingCategory'],
  endpoints: (builder) => ({
    saveParkingCategoryDetail: builder.mutation({
      query(body) {
        return {
          url: spotFinder.parkingCategoryController.saveParkingCategoryDetail,
          method: 'POST',
          headers: { Authorization: `Bearer ${body.token}` },
          body: body.payload,
        };
      },
    }),
    updateParkingCategoryDetail: builder.mutation({
      query(body) {
        return {
          url: spotFinder.parkingCategoryController.updateParkingCategoryDetail,
          method: 'POST',
          headers: { Authorization: `Bearer ${body.token}` },
          body: body.payload,
        };
      },
    }),
    getParkingCategoryDetail: builder.mutation({
      query(body) {
        return {
          url: spotFinder.parkingCategoryController.getParkingCategoryDetail,
          method: 'POST',
          headers: { Authorization: `Bearer ${body.token}` },
          body: body.payload,
        };
      },
    }),
    deleteParkingCategoryDetail: builder.mutation({
      query(body) {
        return {
          url: `${spotFinder.parkingCategoryController.deleteParkingCategoryDetail}${body.id}`,
          method: 'DELETE',
          headers: { Authorization: `Bearer ${body.token}` },
          body: body.payload,
        };
      },
    }),
    getParkingCategoryById: builder.mutation({
      query(body) {
        return {
          url: `${spotFinder.parkingCategoryController.getParkingCategoryById}/${body.id}`,
          method: 'GET',
          headers: { Authorization: `Bearer ${body.token}` },
        };
      },
    }),
   
  }),
});

export const {
  useSaveParkingCategoryDetailMutation,
  useUpdateParkingCategoryDetailMutation,
  useDeleteParkingCategoryDetailMutation,
  useGetParkingCategoryDetailMutation,
  useGetParkingCategoryByIdMutation,
} = parkingCategoryApi;
